module.exports = __webpack_public_path__ + "static/media/banner-revoke.5a7df731.jpg";